//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated by the Rock.CodeGeneration project
//     Changes to this file will be lost when the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
// <copyright>
// Copyright by the Spark Development Network
//
// Licensed under the Rock Community License (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.rockrms.com/license
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
// </copyright>
//

/** Entity Badge */
export const Badge = {
    /** Assessments badge */
    Assessments: "CCE09793-89F6-4042-A98A-ED38392BCFCC",
    /** Attending Duration badge */
    AttendingDuration: "260EAD7D-5073-4F88-A6A9-427F6E95985E",
    /** Baptism badge */
    Baptism: "66972BFF-42CD-49AB-9A7A-E1B9DECA4EBE",
    /** Campus badge */
    Campus: "B21DCD49-AC35-4B2B-9857-75213209B643",
    /** Connection Status badge */
    ConnectionStatus: "66972BFF-42CD-49AB-9A7A-E1B9DECA4EBF",
    /** DISC Personality Assessment Result badge */
    DiscPersonalityAssessmentResult: "6C491A10-E942-4CA5-8D13-ACBC28511714",
    /** eRA badge */
    Era: "7FC986B9-CA1E-CBB7-4E63-C79EAC34F39D",
    /** Family 16 Week Attendance badge */
    Family16WeekAttendance: "66972BFF-42CD-49AB-9A7A-E1B9DECA4EBA",
    /** Family Attendance badge */
    FamilyAttendance: "3F7D648D-D6BA-4F03-931C-AFBDFA24BBD8",
    /** Group Requirements badge */
    GroupRequirements: "132F9C2A-0AF4-4AD9-87EF-7730B284E10E",
    /** In Serving Team badge */
    InServingTeam: "E0455598-82B0-4F49-B806-C3A41C71E9DA",
    /** Last Visit on External Site badge */
    LastVisitOnExternalSite: "8A9AD88E-359F-46FD-9BA1-8B0603644F17",
    /** Personal Devices badge */
    PersonalDevices: "307CB56D-140C-4CC9-8B54-DD551CC40174",
    /** Record Status badge */
    RecordStatus: "66972BFF-42CD-49AB-9A7A-E1B9DECA4ECA",
    /** Top Person Signal badge */
    TopPersonSignal: "B4B336CE-137E-44BE-9123-27740D0064C2",
};
